let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7Bhs")).then(() => parcelRequire('bOJ1T'));